import { InjectionToken } from "@angular/core";

export const LOGS_URL = new InjectionToken<string>("logsUrl");
